import React from 'react'

const Welcome = () => {
    const aiIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <g filter="url(#filter0_di_714_3965)">
            <rect x="15" y="2" width="70" height="70" rx="20" fill="url(#paint0_linear_714_3965)"/>
            <path d="M61.8639 40.8702C53.6134 43.596 50.866 46.344 48.1401 54.594C47.9158 55.2723 46.9568 55.2723 46.7325 54.594C44.0067 46.3435 41.2588 43.5961 33.0087 40.8702C32.3304 40.6459 32.3304 39.6869 33.0087 39.4626C41.2592 36.7368 44.0066 33.9889 46.7325 25.7388C46.9568 25.0605 47.9159 25.0605 48.1401 25.7388C50.8659 33.9893 53.6139 36.7367 61.8639 39.4626C62.5422 39.6869 62.5422 40.646 61.8639 40.8702Z" fill="white"/>
            <path d="M67.8479 27.321C63.7236 28.683 62.3489 30.0578 60.9851 34.1838C60.8738 34.523 60.3943 34.523 60.2813 34.1838C58.9192 30.0595 57.5445 28.6849 53.4184 27.321C53.0793 27.2098 53.0793 26.7303 53.4184 26.6172C57.5427 25.2552 58.9174 23.8804 60.2813 19.7543C60.3925 19.4152 60.872 19.4152 60.9851 19.7543C62.3471 23.8786 63.7218 25.2533 67.8479 26.6172C68.187 26.7284 68.187 27.2079 67.8479 27.321Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_di_714_3965" x="0" y="0" width="100" height="100" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="13"/>
            <feGaussianBlur stdDeviation="7.5"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.592157 0 0 0 0 0.203922 0 0 0 0 0.980392 0 0 0 0.26 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_714_3965"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_714_3965" result="shape"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="12.6"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.451725 0 0 0 0 0 0 0 0 0 0.894231 0 0 0 1 0"/>
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_714_3965"/>
            </filter>
            <linearGradient id="paint0_linear_714_3965" x1="50" y1="2" x2="50" y2="72" gradientUnits="userSpaceOnUse">
            <stop stop-color="#7351FD"/>
            <stop offset="1" stop-color="#A33BFF"/>
            </linearGradient>
            </defs>
        </svg>
    )

    return (
        <div className='w-[316px] mx-auto flex flex-col items-center h-full gap-8 mt-6'>
            {aiIcon}

            <div>
                <h6 className='text-center text-base text-body font-medium'>Hi {EASYCOMMERCE.user.data.display_name},</h6>
                <h4 className='text-center text-xl text-ec-title font-medium my-3'>Welcome Back! How can I help?</h4>
                <p className='block text-center text-sm text-ec-light-black '>
                    Need help managing your store? I’m your AI Assistant. Ask me anything about EasyCommerce.
                </p>
            </div>
        </div>
    )
}

export default Welcome